import { heroContent, stats } from "../../data/mock";
import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";

export const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-gradient-to-br from-[#FAFAF8] via-white to-[#F0EDE5]">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage: "radial-gradient(circle, #0F172A 1px, transparent 1px)",
            backgroundSize: "32px 32px",
          }}
        />
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-[#C8A951]/8 blur-[150px]" />
        <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] rounded-full bg-[#0F172A]/3 blur-[120px]" />
        <div className="absolute top-32 right-[10%] w-px h-48 bg-gradient-to-b from-transparent via-[#C8A951]/20 to-transparent hidden lg:block" />
        <div className="absolute top-48 right-[10%] w-24 h-px bg-gradient-to-r from-[#C8A951]/20 to-transparent hidden lg:block" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-28 pb-16 w-full">
        <div className="max-w-4xl">
          {/* Main Tagline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[#0F172A] leading-[1.08] mb-4 tracking-tight">
            {heroContent.headline}
            <br />
            <span className="bg-gradient-to-r from-[#C8A951] to-[#A88B3D] bg-clip-text text-transparent">
              {heroContent.headlineAccent}
            </span>
          </h1>

          {/* Subline - only show if content exists */}
          {heroContent.subline && (
            <p className="text-lg sm:text-xl text-[#0F172A]/60 font-medium tracking-wide mb-8">
              {heroContent.subline}
            </p>
          )}

          {/* Paragraph */}
          <p className="text-lg sm:text-xl text-[#475569] max-w-2xl mb-10 leading-relaxed">
            {heroContent.subtext}
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap items-center gap-4 mb-16">
            <a href="#why-iqhub">
              <Button className="bg-[#C8A951] hover:bg-[#B8993F] text-[#0F172A] font-semibold text-base px-8 py-6 rounded-lg group">
                Learn More
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
            <a href="#industries">
              <Button
                variant="outline"
                className="border-[#C8A951]/50 text-[#0F172A] hover:bg-[#C8A951]/10 hover:border-[#C8A951] text-base px-8 py-6 rounded-lg group bg-transparent"
              >
                Discover Our Industries
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </div>

          {/* Stats Bar */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 pt-10 border-t border-[#0F172A]/10">
            {stats.map((stat, i) => (
              <div key={i} className="group">
                <div className="text-3xl sm:text-4xl font-bold text-[#0F172A] mb-1 tracking-tight">
                  {stat.value}
                </div>
                <div className="text-sm text-[#64748B] group-hover:text-[#C8A951] transition-colors duration-300">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
